import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=cd17632c&lang=scss&scoped=true"

import exportComponent from "E:\\phpstudy_pro\\WebWWW\\client-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd17632c"]])

export default __exports__